import { NTRole,  RoleService, RoleType } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { ResultData } from "@nt-portal/common-sdk";

export interface RolesOptions extends ControllerOptions<NTRole> {
    roleType?: RoleType
}

export const initRole = () => {
    let item: NTRole = {
        name: '', id: '', roleType: "module", description: "", level: 5,
        createdBy: "", key: ""
    }
    return item;
}

export class ClientRoleService extends BaseClientService implements DataController<NTRole> {

    private _service: RoleService;


    constructor() {
        super();
        this._service = new RoleService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
    
   public async get(options: RolesOptions): Promise<ResultData<NTRole>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.roleType);
       
    }
    public async getLookup(options: RolesOptions): Promise<ResultData<NTRole>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, options.filter, options.roleType);
        return data;
    }

    public async getById(options: RolesOptions): Promise<NTRole | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: RolesOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: RolesOptions): Promise<NTRole | NTRole[] | null> {
        if (options.item )
            return await this._service.update(options.item, this.token)
        return null;
    }
    public async add(options: RolesOptions): Promise<NTRole | NTRole[] | null> {
        if (options.item )
            return await this._service.add(options.item, this.token)
        return null;
    }
   


}